import axios from "axios";
import { openBlankTab, openFile, saveFile } from "../../../native/files";

// Kundenportal API (/api/portal): the server binds everything to the logged-in customer.
const base = `${process.env.REACT_APP_BACKEND_URL}/portal`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });

export const getOverview = () => axios.get(`${base}/overview`, headers());
export const listOffers = () => axios.get(`${base}/offers`, headers());
export const getOffer = id => axios.get(`${base}/offers/${id}`, headers());
export const decideOffer = (id, body) =>
  axios.post(`${base}/offers/${id}/decision`, body, headers());
export const getChangeOrder = id => axios.get(`${base}/change-orders/${id}`, headers());
export const decideChangeOrder = (id, body) =>
  axios.post(`${base}/change-orders/${id}/decision`, body, headers());
export const changeOrderPhotoUrl = (id, photoId) =>
  `${base}/change-orders/${id}/photos/${photoId}?token=${encodeURIComponent(localStorage.getItem("token") || "")}`;
export const listInvoices = () => axios.get(`${base}/invoices`, headers());
export const getInvoice = id => axios.get(`${base}/invoices/${id}`, headers());
export const listAppointments = () => axios.get(`${base}/appointments`, headers());
export const listDocuments = () => axios.get(`${base}/documents`, headers());
export const listThreads = () => axios.get(`${base}/messages`, headers());
export const getThread = key =>
  axios.get(`${base}/messages/${key === "general" ? "general" : `projects/${key}`}`, headers());
export const postMessage = (key, text) =>
  axios.post(
    `${base}/messages/${key === "general" ? "general" : `projects/${key}`}`,
    { text },
    headers()
  );
export const getProfile = () => axios.get(`${base}/profile`, headers());
export const updateConsent = body => axios.put(`${base}/profile/consent`, body, headers());

// A proposed appointment slot is confirmed through the appointment API (same rules as before)
export const confirmSlot = (appointmentId, scheduleIndex) =>
  axios.put(
    `${process.env.REACT_APP_BACKEND_URL}/appointments/confirm-schedule`,
    { appointmentId, scheduleIndex, tz: Intl.DateTimeFormat().resolvedOptions().timeZone },
    headers()
  );

/** Fetches a PDF/file of the portal and shows it (web: new tab; app: share sheet). */
export const openPortalFile = async (path, fileName, { download = false } = {}) => {
  const tab = download ? null : openBlankTab();
  try {
    const res = await axios.get(`${base}${path}`, { ...headers(), responseType: "blob" });
    if (download) await saveFile(res.data, fileName);
    else await openFile(res.data, { tab, fileName });
  } catch (error) {
    if (tab) tab.close();
    throw error;
  }
};

// The invitation link (no login; the tenant comes from ?domain=)
const publicBase = `${process.env.REACT_APP_BACKEND_URL}/public-portal`;
const domainQuery = domain => `?domain=${encodeURIComponent(domain || "")}`;
export const getInvite = (token, domain) =>
  axios.get(`${publicBase}/invites/${token}${domainQuery(domain)}`);
export const activateInvite = (token, domain, body) =>
  axios.post(`${publicBase}/invites/${token}/activate${domainQuery(domain)}`, body);

/** The server's error text, else the fallback. */
export const errorText = (error, fallback) => error?.response?.data?.errorMessage || fallback;
